import { cn } from "@/lib/utils"
import { ReactNode } from "react"

export type CardProps = {
  className?: string
  /**
   * Pass tailwind bg-* classes to change the accent color
   **/
  accent?: string
  children?: ReactNode
}

export default function Card({
  className,
  accent = "bg-button-black",
  children,
}: CardProps) {
  return (
    <article
      className={cn(
        `
          relative overflow-hidden rounded-lg bg-white px-3 py-4
          shadow-xs
        `,
        className
      )}
    >
      <div className={cn("absolute top-0 left-0 h-1 w-full", accent)}></div>

      {children}
    </article>
  )
}
